import { render, staticRenderFns } from "./CohortChildren.vue?vue&type=template&id=1df8fc6c&scoped=true"
import script from "./CohortChildren.vue?vue&type=script&lang=js"
export * from "./CohortChildren.vue?vue&type=script&lang=js"
import style0 from "./CohortChildren.vue?vue&type=style&index=0&id=1df8fc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df8fc6c",
  null
  
)

export default component.exports